export var defaultProps = {
  spacingSpace: {
    x: 2,
    y: 2
  },
  color: "background"
};